(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vestige-about"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const init = (section) => {
      if (!section || section.dataset.vaReady === 'true') return;
      section.dataset.vaReady = 'true';
      if (reduce || !('IntersectionObserver' in window)) return;

      section.classList.add('va-anim-ready');

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0, rootMargin: '0px 0px -8% 0px' }
      );

      section.querySelectorAll('[data-va-reveal]').forEach((el) => observer.observe(el));
    };

    document.querySelectorAll('[data-va-anim]').forEach(init);

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.matches('[data-va-anim]')
        ? event.target
        : event.target.querySelector('[data-va-anim]');
      init(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vestige-home-bottom"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const init = (section) => {
      if (!section || section.dataset.vhbReady === 'true') return;
      section.dataset.vhbReady = 'true';
      if (reduce || !('IntersectionObserver' in window)) return;

      section.classList.add('vhb-anim-ready');

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0, rootMargin: '0px 0px -8% 0px' }
      );

      section.querySelectorAll('[data-vhb-reveal]').forEach((el) => observer.observe(el));
    };

    document.querySelectorAll('[data-vhb-anim]').forEach(init);

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.matches('[data-vhb-anim]')
        ? event.target
        : event.target.querySelector('[data-vhb-anim]');
      init(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vestige-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (section) => {
      if (!section || section.dataset.vInitialised === 'true') return;
      section.dataset.vInitialised = 'true';

      const hero = section.querySelector('[data-v-hero]');
      const sticky = section.querySelector('.v-hero__sticky');
      const letters = section.querySelectorAll('[data-v-letter]');
      const pageWrapper = section.closest('.page-wrapper') || document.querySelector('.page-wrapper');
      const scrollContainer = pageWrapper || window;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const updateHero = () => {
        if (!hero || reduceMotion) return;
        const rect = hero.getBoundingClientRect();
        // Measure the scroll sequence against the pinned element's own height rather
        // than window.innerHeight. On mobile the URL bar collapses/expands mid-scroll,
        // which changes innerHeight and made progress jitter; the sticky height is a
        // stable reference tied to the same viewport unit, so progress stays smooth.
        const stickyHeight = sticky ? sticky.offsetHeight : window.innerHeight;
        const distance = Math.max(hero.offsetHeight - stickyHeight, 1);
        const progress = Math.min(Math.max(-rect.top / distance, 0), 1);
        const isMobile = window.matchMedia('(max-width: 749px)').matches;

        section.style.setProperty('--v-scroll', progress.toFixed(4));
        section.style.setProperty('--v-glow-one-opacity', (.2 + progress * .7).toFixed(3));
        section.style.setProperty('--v-glow-one-x', `${(progress * 24).toFixed(3)}vw`);
        section.style.setProperty('--v-glow-one-y', `${(progress * 14).toFixed(3)}vh`);
        section.style.setProperty('--v-glow-one-scale', (.75 + progress * .65).toFixed(3));
        section.style.setProperty('--v-glow-two-opacity', (.15 + progress * .45).toFixed(3));
        section.style.setProperty('--v-glow-two-x', `${(progress * -20).toFixed(3)}vw`);
        section.style.setProperty('--v-glow-two-y', `${(progress * -8).toFixed(3)}vh`);
        section.style.setProperty('--v-edition-opacity', Math.max(1 - progress * 1.5, 0).toFixed(3));

        if (isMobile) {
          // Mobile choreography: vertical only so the wordmark never overflows a narrow
          // screen. The word drifts up, grows as if you move through it, and dissolves
          // into a soft blur — "something remains". Per-letter motion below erodes the
          // outer letters first while the core holds, on brand for the release.
          section.style.setProperty('--v-wordmark-y', `${(progress * -7).toFixed(3)}vh`);
          section.style.setProperty('--v-wordmark-scale', (1 + progress * .16).toFixed(3));
          section.style.setProperty('--v-wordmark-blur', `${(Math.max(progress - .55, 0) / .45 * 3).toFixed(2)}px`);
        } else {
          section.style.setProperty('--v-wordmark-y', `${(progress * -5).toFixed(3)}vh`);
          section.style.setProperty('--v-wordmark-scale', (1 + progress * .06).toFixed(3));
          section.style.setProperty('--v-wordmark-blur', '0px');
          section.style.setProperty('--v-letter-opacity', (1 - progress * .38).toFixed(3));
        }

        letters.forEach((letter) => {
          const index = Number(letter.dataset.letterIndex);
          const offset = Number.isFinite(index) ? index - 3 : 0;
          if (isMobile) {
            // Vertical parabola: outer letters sink, centre letters hold. No horizontal
            // travel, so nothing is ever clipped off the side of the phone.
            const y = offset * offset * progress * .55;
            const opacity = Math.max(1 - progress * (.25 + Math.abs(offset) * .16), .05);
            letter.style.transform = `translate3d(0, ${y.toFixed(3)}vh, 0)`;
            letter.style.opacity = opacity.toFixed(3);
          } else {
            const x = offset * progress * 1.7;
            const y = offset * offset * progress * .34;
            letter.style.transform = `translate3d(${x.toFixed(3)}vw, ${y.toFixed(3)}vh, 0)`;
            letter.style.removeProperty('opacity');
          }
        });
      };

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
      );

      section.querySelectorAll('[data-v-reveal]').forEach((item) => observer.observe(item));

      let framePending = false;
      const requestUpdate = () => {
        if (framePending) return;
        framePending = true;
        window.requestAnimationFrame(() => {
          updateHero();
          framePending = false;
        });
      };

      updateHero();

      // If rAF is paused (hidden tab, iOS low-power, bfcache restore) the pending
      // flag can latch on and freeze the hero permanently. Clear it and resync
      // whenever the page becomes visible again.
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) return;
        framePending = false;
        updateHero();
      });
      window.addEventListener('pageshow', () => {
        framePending = false;
        updateHero();
      });

      scrollContainer.addEventListener('scroll', requestUpdate, { passive: true });
      // Fallback: some mobile layouts scroll the window itself rather than the theme's
      // .page-wrapper. Listening to both (rAF-deduped) keeps the hero in sync either way.
      if (scrollContainer !== window) {
        window.addEventListener('scroll', requestUpdate, { passive: true });
      }
      window.addEventListener('resize', requestUpdate);
    };

    document.querySelectorAll('[data-vestige-release]').forEach(initialise);

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.matches('[data-vestige-release]')
        ? event.target
        : event.target.querySelector('[data-vestige-release]');
      initialise(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
